<template>
  <div class="home">
    <div class="title">
      <span>本月累计</span>
      <div>
        <el-select v-model="valueHome" filterable placeholder="请选择" @change="changeClick">
          <el-option
            v-for="item in optionsHome"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="main">
      <div class="echarts-name">本月交易数据</div>
      <div class="lists">
        <!-- :style="'background: url(' + list.img + ');background-size: 100% 100%;'" -->
        <div class="list" v-for="(list,key) in TradingData" :key="key" :style="list.background">
          <div class="name">{{list.name}}</div>
          <div class="price">{{list.price}}</div>
        </div>
      </div>
      <div class="echarts-name">本月累计总付款金额</div>
      <div class="echarts">
        <div id="container" style="height: 100%"></div>
      </div>
      <div class="echarts-name">本月业务办理</div>
      <div class="lists">
        <!-- :style="'background: url(' + list.img + ');background-size: 100% 100%;'" -->
        <div class="list" v-for="(list,key) in BusinessData" :key="key" :style="list.background">
          <div class="name">{{list.name}}</div>
          <div class="price">{{list.price}}</div>
        </div>
      </div>
      <div class="echarts-name">本月交付商业务概览</div>
      <div class="main_table">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{background:'rgb(250, 250, 250)'}"
          style="width: 867px"
        >
          <el-table-column prop="deliverName" label="交付商名称" width="180" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="completeCount" label="已完成订单" width="180" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="handlingCount" label="办理中订单" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="servicePrice" label="服务费" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
import navigationBar from "@/components/navigationBar";
export default {
  data () {
    return {
      total: null,
      pageSize: 10,
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      TradingData: [
        {
          name: "业务订单量",
          price: "28笔",
          background:
            "background:linear-gradient(90deg,rgba(66,219,214,1) 0%,rgba(16,153,209,1) 100%);"
        },
        {
          name: "订单交易额",
          price: "¥182930元",
          background:
            "background:linear-gradient(90deg,rgba(149,111,253,1) 0%,rgba(253,93,159,1) 100%);"
        }
      ],
      BusinessData: [
        {
          name: "已完成订单量",
          price: "3笔",
          background:
            "background:linear-gradient(90deg,rgba(66,219,214,1) 0%,rgba(16,153,209,1) 100%);"
        },
        {
          name: "待分配订单量",
          price: "7笔",
          background:
            "background:linear-gradient(90deg,rgba(149,111,253,1) 0%,rgba(253,93,159,1) 100%);"
        },
        {
          name: "待审核订单量",
          price: "9家",
          background:
            "background:linear-gradient(270deg,rgba(248,205,138,1) 0%,rgba(243,91,105,1) 100%);"
        },
        {
          name: "交付商办理中订单量",
          price: "15笔",
          background:
            "background:linear-gradient(90deg,rgba(118,79,253,1) 0%,rgba(167,205,254,1) 100%);"
        }
      ],
      optionsHome: [
        {
          value: "1",
          label: "本月"
        },
        {
          value: "2",
          label: "上月"
        },
        {
          value: "3",
          label: "总计"
        }
      ],
      valueHome: "1",
      paymentOption: {
        grid: {
          left: 0,
          top: "10%",
          right: 0,
          bottom: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#2EACFF",
              width: 1 //这里是为了突出显示加上的
            }
          },
          data: [
            "2019-07-01",
            "2019-07-04",
            "2019-07-07",
            "2019-07-10",
            "2019-07-13",
            "2019-07-16",
            "2019-07-19"
          ]
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#2EACFF",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
        series: [
          {
            data: [],
            type: "line",
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#764FFD"
                  },
                  {
                    offset: 0.5,
                    color: "#FD5D9F"
                  },
                  {
                    offset: 1,
                    color: "#956FFD"
                  }
                ])
              }
            },
            color: {}
          },
          {
            data: [],
            type: "line",
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#1493FA"
                  },
                  {
                    offset: 0.5,
                    color: "#1396FA"
                  },
                  {
                    offset: 1,
                    color: "#04C0F9"
                  }
                ])
              }
            },
            color: {}
          }
        ]
      },
      myChart: null
    };
  },
  components: {
    navigationBar: navigationBar,
    pagination: pagination
  },
  mounted() {
    //
    this.myChart = this.$echarts.init(document.getElementById("container"));

    this.myChart.setOption(this.paymentOption, true);

    window.onresize = () => {
      this.myChart.resize();
    };
    this.$forceUpdate();
    // 图
    this.transDataPost();
    this.deliverDataPost();
    this.businessDataPost();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.deliverDataPost();
    },
    handleCurrentChange(size) {
      console.log(size);
      this.deliverDataPost(size);
    },
    changeClick(val) {
      console.log(val);
      console.log(this.valueHome);
      this.transDataPost();
      this.deliverDataPost();
      this.businessDataPost();
    },
    businessDataPost() {
      post(api.businessData, {
        type: this.valueHome
      }).then(
        d => {
          console.log(d, "????????????????");
          if (d.status === 0) {
            console.log(d, "数据");
            this.BusinessData[0].price = d.data.completeCount;
            this.BusinessData[1].price = d.data.toApplyCount;
            this.BusinessData[2].price = d.data.toAuditCount;
            this.BusinessData[3].price = d.data.handlingCount;
            this.$forceUpdate();
          }
        },
        err => {
          //error callback
        }
      );
    },
    deliverDataPost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: 'loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.deliverData, {
        currentPage: size || 1,
        pageSize: this.pageSize,
        type: this.valueHome
      }).then(
        d => {
          console.log(d, "????????????????");
           loading.close();
          if (d.status === 0) {
            console.log(d, "列表");
            this.total = d.data.count;
            this.tableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    transDataPost() {
      post(api.transData, {
        type: this.valueHome
      }).then(
        d => {
          console.log(d, "????????????????");
          if (d.status === 0) {
            console.log(d, "信息图表");
            this.TradingData[0].price = d.data.orderCount + "笔";
            this.TradingData[1].price = "￥" + d.data.orderPrice + "元";
            var temp = this.paymentOption;
            temp.xAxis.data = d.data.days;
            // d.data.dayCounts
            temp.series[0].data = d.data.dayCounts;
            temp.series[1].data = d.data.priceCounts;
            this.myChart.setOption(temp);
          }
        },
        err => {
          //error callback
        }
      );
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  padding: 16px 20px;
  box-sizing: border-box;
  .title {
    width: 100%;
    overflow: hidden;
    span {
      float: left;
      font-size: 16px;
      line-height: 40px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    div {
      float: right;
      width: 170px;
      overflow: hidden;
    }
  }
  .main {
    width: 100%;
    margin-top: 15px;
    // height: 200%;
    background-color: #fff;
    padding: 40px;
    box-sizing: border-box;
    .lists {
      width: 100%;
      height: 124px;
      .list {
        float: left;
        width: 262px;
        height: 100%;
        margin-right: 1.5%;
        border-radius: 6px;
        padding: 24px;
        box-sizing: border-box;
        text-align: left;
        .name {
          font-size: 13px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        .price {
          margin-top: 30px;
          // padding-left: 30px;
          font-size: 20px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
      .list:last-child {
        margin-right: 0px;
      }
    }
    .echarts-name {
      width: 100%;
      margin: 15px 0px;
      text-align: left;
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .echarts {
      width: 100%;
      height: 328px;
    }
    .main_table {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue